.de{color:var(--brand-primary);}